import { Pitch } from './pitch';

export class Venue {
    type = 'venues';
    id: number | null;
    attributes: {
        name: string,
        address1: string,
        address2: string,
        postcode: string,
        town: string,
        council: string
    };
    relationships: {
        pitches: {
            data: Array<Pitch>
        }
    };

}
